<template>
  <div>
    <div class="gj_top_search">
      <input type="button" style="margin-right: 0;" class="btn_s_gj" @click="search($event)" /><!-- gap eliminated
      --><span class="put_gjef">
        <input type="text" placeholder="输入标签、公司名..." @keyup.enter="search($event)" @input="search($event)" class="put_gj" v-model="searchText" style="border: 0; margin: 0;" />
        <span @click.stop="searchText = ''" style="position: absolute; top: 0; right: 12px; cursor: pointer; color: #606266;">x</span>
    </span>
    </div>
    <div v-if="lists.length > 0" style="padding: 5px; height: 230px; overflow: scroll;">
      <li v-for="item in lists" :key="item.id" @click.stop="nodeClick(item)" style="cursor: pointer;">
        <a>{{item.name}}</a>
      </li>
    </div>
    <h5 class="none_ts" v-if="lists.length == '0'">
      <img src="@/assets/images/none_data.jpg" alt="">
    </h5>
  </div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  export default {
    data () {
      return {
        searchText: '',
        lists: []
      }
    },
    methods: {
      nodeClick(item) {
        this.$emit('node-clicked', item)
      },
      search (e) {
        var that = this
        if (this.searchText) {
          api.post(config.bylApiPath, '/dep/searchByNameAndTagName', {searchByNameAndTagName: this.searchText}, (r) => { // 正常
            if (r.data) {
              this.lists = r.data
            } else {
              this.lists = []
            }
          })
        } else {
          this.lists = []
        }
      }
    }
  }
</script>
<style scoped>
  @import './index.css';
</style>



// WEBPACK FOOTER //
// src/page/byl/org/structure/customsearch/index.vue